import React from "react";
import { Form, Input, Row, Col } from "antd";
import { Validator } from "@/utils/validator";

export default function TransferVehicleForm({ formRef, onSubmit }) {
  return (
    <Form layout="vertical" form={formRef} onFinish={onSubmit}>
      <Row gutter={16}>
        <Col lg={24}>
          <p>Please enter full shipment ID of shipment to transfer to.</p>
          <Form.Item
            name="shipmentId"
            label="Shipment ID"
            rules={Validator.guid("Invalid Shipment ID.  Please make sure to provide all 36 characters.")}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
